import { withAuthenticationRequired } from '@tom-ui/utils'
import { VesselVisitKPI } from '@tom-ui/operations'
import { usePlanningStore, VesselVisitKPIOverview } from '@tom-ui/planning'
import { getVesselVisitKPIStats } from '@tom-ui/planning/utils/order-utils'
import { observer } from 'mobx-react-lite'
import { useCallback, useMemo } from 'react'
import { useParams } from 'react-router'

export const VesselVisitTPR = withAuthenticationRequired(
  observer(() => {
    const { id } = useParams<{ id: string }>()
    const visitId = Number(id)
    const { vesselVisitItemStore } = usePlanningStore()

    const vesselVisitItem = vesselVisitItemStore.getById(visitId)

    const vesselVisitKPIStats = useMemo(
      () => getVesselVisitKPIStats(vesselVisitItem),
      [vesselVisitItem],
    )

    const renderVesselVisitKPIOverview = useCallback((minutesLeft: number) => {
      return <VesselVisitKPIOverview visitId={visitId} minutesLeft={minutesLeft} />
    }, [])

    return (
      <VesselVisitKPI
        visitOverviewComponent={renderVesselVisitKPIOverview}
        vesselVisitKPIStats={vesselVisitKPIStats}
      />
    )
  }),
)
